<template>
  <TemplateEdit v-loading="editLoading" :get-data="getData" :edit-title="editTitle" ref="edit" class="news-edit-container">
      <el-form label-width="100px" size="small" :rules="rules" :model="editData" ref="editForm" class="bg-white p-3">
        <el-row type="flex" class="flex-wrap">
          <form-item label="分类" prop="cateid" fill="4">
            <el-select v-loading="loading.newscateList" v-model="editData.cateid" filterable multiple :multiple-limit="3">
              <template v-for="item in newscateList">
                <el-option v-if="hasCate(item.id)" :label="item.name" :value="item.id" :key="item.id" :disabled="item.issingle || (item.outurl != null && item.outurl != '')">
                  {{ !item.parentid ? '' : (space2 +'- ') }}{{ item.name }}
                </el-option>
              </template>
            </el-select>
          </form-item>
          <form-item v-if="isXy" label="第二分类" prop="xycateid" fill="4">
            <el-radio-group v-model="editData.xycateid">
              <el-radio v-for="(v, k) in xycatemap" :key="k" :label="k">{{v}}</el-radio>
            </el-radio-group>
          </form-item>
          <form-item label="选项" fill="4">
            <div class="d-flex align-items-center">
              <el-switch v-model="editData.istop" active-text="置顶" />
              <el-switch v-model="editData.isfocus" active-text="首页图片新闻" class="ml-4" />
              <el-switch v-model="editData.needip" active-text="仅授权IP访问" class="ml-4" />
              <el-switch v-model="editData.othertop" active-text="其他分类置顶" class="ml-4" />
              <el-popover trigger="hover">
                <div slot="reference" class="text-info"><i class="el-icon-info"></i> 说明</div>
                <div>其他分类：当发布内容到多个分类时，【其他分类】指除第一个分类以外的类别</div>
              </el-popover>
            </div>
          </form-item>
          <!-- <form-item label="引题" prop="title1" fill="4" wrap>
            <el-input v-model="editData.title1"></el-input>
          </form-item> -->
          <form-item label="标题" prop="title" fill="4" wrap>
            <el-input v-model="editData.title"></el-input>
          </form-item>
          <form-item label="外部链接" prop="outurl" fill="4" wrap>
            <el-input v-model="editData.outurl"></el-input>
          </form-item>
          <form-item label="来源" prop="source" fill="4" wrap>
            <el-input v-model="editData.source"></el-input>
          </form-item>
          <form-item label="审稿人" prop="sgr" fill="4" wrap>
            <el-input v-model="editData.sgr"></el-input>
          </form-item>

          <form-item label="上传审稿资料"  fill="4">
            <el-upload
                class="avatar-uploader company-uploader"
                :headers="headers"
                :action="uploadPic"
                :show-file-list="false"
                :on-success="handleUploadSuccessok"
                :before-upload="beforeUpload"
                accept=".jpg,.png"
            >
              <img v-if="editData.sgjpg" :src="rootPath + editData.sgjpg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <JyButton v-if="editData.sgjpg" class="text-danger" is-a @click.stop="delPic2">删除图片</JyButton>
            </el-upload>
          </form-item>


          <form-item label="浏览量" prop="hits" fill="4" wrap>
            <el-input type="number" v-model.number="editData.hits"></el-input>
          </form-item>
          <form-item label="题图" fill="4">
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
              :before-upload="beforeUpload"
              accept=".jpg,.png"
            >
              <img v-if="editData.pic" :src="rootPath + editData.pic" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <JyButton v-if="editData.pic" class="text-danger" is-a @click.stop="delPic">删除图片</JyButton>
            </el-upload>
          </form-item>
          <form-item label="发布视频" fill="4">
            <el-radio-group v-model="videotype">
              <el-radio :label="1">上传视频</el-radio>
              <el-radio :label="2">在线视频地址</el-radio>
              <el-radio :label="3">第三方平台视频代码</el-radio>
            </el-radio-group>
          </form-item>
          <form-item v-if="videotype == 1" label="上传视频" fill="4">
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :show-file-list="false"
              :on-success="handleUploadSuccessVideo"
              accept=".mp4"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-if="editData.video1">
              <span>{{ editData.video1 }}</span>
              <el-button @click="videoVisible = true">预览视频</el-button>
              <JyButton class="text-danger" is-a @click.stop="delVideo">删除视频</JyButton>
            </div>
          </form-item>
          <form-item v-if="videotype == 2" label="在线视频" fill="4">
            <el-input v-model="editData.video2">
              <el-button v-if="editData.video2" slot="append" @click="videoVisible = true">预览视频</el-button>
            </el-input>
          </form-item>
          <form-item v-if="videotype == 3" label="第三方平台视频代码" fill="4">
            <el-input type="textarea" v-model="editData.video3" :autosize="{minRows:2}">
              <el-button v-if="editData.video3" slot="append" @click="videoVisible = true">预览视频</el-button>
            </el-input>
          </form-item>
          <form-item label="发布时间" prop="createtime" fill="4">
            <el-date-picker
              v-model="editData.createtime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择发布时间">
            </el-date-picker>
          </form-item>
          <form-item label="内容" prop="content" fill="4">
            <tinymce
              v-if="show"
              v-model="editData.content"
              :basePath="assetsPath"
              :rootPath="rootPath"
              @imgInsert="imgInsert"
            />
          </form-item>
          <form-item label="上传附件" fill="4">
            <el-upload
              class="avatar-uploader company-uploader"
              :headers="headers"
              :action="uploadPic"
              :data="{needoldname: true}"
              :show-file-list="false"
              :on-success="handleUploadSuccessFile"
              accept=".docx,.doc,.xls,.xlsx,.zip,.rar,.pdf,.ppt,.pptx,.jpg,.png,.txt"
              multiple
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="d-flex flex-column">
              <div v-for="(item, index) in fileList" :key="index" class="mr-2">
                <a :href="rootPath + item" target="hyjy_download" download>{{ item }}</a>
                <JyButton class="ml-2 text-danger" is-a @click.stop="delFile(item, index)">删除文件</JyButton>
              </div>
            </div>
          </form-item>
        </el-row>
      </el-form>
      <template v-slot:footer>
      <JyButton type="dark" is-outline icon="reply" @click="$router.go(-1)" class="mr-2">返回</JyButton>
      <JyButton type="success" icon="save" :isLoading="saveLoading" class="mr-2" @click="doSave()">{{ editData.id ? '确定更新' : '确定发布' }}</JyButton>
    </template>
    <JyDialog :visible.sync="videoVisible" title="视频预览" max-width="600px" moveable>
      <video v-if="editData.video1" :src="rootPath + editData.video1" class="w-100" controls="controls">
      </video>
      <video v-if="editData.video2" :src="editData.video2" class="w-100" controls="controls">
      </video>
      <div v-if="editData.video3" v-html="editData.video3" class="w-100">
      </div>
    </JyDialog>
  </TemplateEdit>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import TemplateEdit from '../template-edit.vue';
import tinymce from '@/components/tinymce-editor';
import tools from 'jyutils/tools';
import { parseDate } from 'element-ui/src/utils/date-util';
import { deepCopy } from 'jyutils/utils';
export default {
  components: { TemplateEdit, tinymce },
  mixins: [tools],
  props: {
    id: String
  },
  data() {
    return {
      show: false,
      editTitle: '',
      editLoading: false,
      saveLoading: false,
      editImgs: [],
      videotype: 0,
      videoVisible: false,
      fileList: [],
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      xycatemap: {
        '10': '党建工作',
        '9': '干部工作',
        '25': '党校工作'
      }
    }
  },
  computed: {
    ...mapGetters({
      newscateList: [types.BASE_LOAD.newscateList],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    defaultData() {
      return {
        cateid:[], cateid2:null, cateid3:null, title:'', title1:null, title2:null, summary:null, content:'', createtime:new Date(),
        pic:null, istop:false, isfocus:false, source:null, outurl:null, hits:0, files:null, video1:null, video2:null, video3:null,
        othertop: false, needip:false, sgr: null, sgjpg: null
      }
    },
    rules() {
      return {
        cateid: {required:true, message:'请选择分类！'},
        xycateid: {required:true, message:'请选择第二分类！'},
        title: {required:true, message:'标题必填！'},
        createtime: {required:true, message:'发布时间必填！'},
        uptime: {required:false, message:'请选择开始时间'},
        hits: {required:true, type:'integer', min:0, message:'请输入正整数！'},
        sgr: {required: this.issgr, message: '请输入审稿人！'}
      }
    },
    isXy() {
      return this.userinfo.roleids.includes('17ac5d6f087f44b3aa900216d0cba21e');
    },
    isSignup() {
      return this.editData.issignup;
    },
    cates() {
      if (!this.editData.cateid) {
        return [];
      }
      let cates = this.newscateList.filter(d => {
        return d.id == this.editData.cateid || this.editData.cateid.indexOf(d.id) > -1;
      });
      return cates;
    },
    issgr() {
      return this.cates.some(d => {
        return d.issgr;
      })
    },
    pickerOptions1() {
      let start = this.editData.uptime ? parseDate(this.editData.uptime, 'yyyy-MM-dd HH:mm:ss').getTime() : null;
      return  {
        disabledDate(time) {
          start = start || Date.now();
          return time.getTime() < start;
        }
      }
    },
  },
  watch: {
    id() {
      this.getData();
    },
    isSignup() {
      this.$refs.editForm.clearValidate();
    },
    'editData.isup'(val) {
      this.rules.uptime.required = !val;
      this.$nextTick(() => {
        this.$refs.editForm.validateField('uptime');
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.confirmSave(
      `未保存内容 [ ${this.editData.title || ''} ] ，确定要离开吗？`,
      () => {
        this.show = false;
        next();
      },
      () => {
        next(false);
      }
    );
  },
  methods: {
    getData() {
      this.editLoading = true;
      this.editData = {};
      this.videotype = 0;
      this.show = false;
      if (this.id) {
        this.doGet({
          url: 'sys/news/getById/'+ this.id,
          okcb: (json) => {
            console.log(json)
            let cateid = [json.cateid];
            if (json.cateid2) {
              cateid.push(json.cateid2);
            }
            if (json.cateid3) {
              cateid.push(json.cateid3);
            }
            if (json.cateid4) {
              cateid.push(json.cateid4);
            }
            this.editData = Object.assign({}, this.editData, json, {cateid: cateid});
            if (json.video1) {
              this.videotype = 1;
            } else if (json.video2) {
              this.videotype = 2;
            } else if (json.video3) {
              this.videotype = 3;
            }
            this.initEditData();
          },
          cb: () => {
            this.editLoading = false;
          }
        });
      } else {
        this.editData = Object.assign({}, this.defaultData, {createtime: this.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')});
        this.initEditData();
        this.editLoading = false;
      }
      if (!this.newscateList || !this.newscateList.length) {
        this.$store.dispatch(types.BASE_LOAD.newscateList);
      }
    },
    initEditData() {
      this.editTitle = (this.editData.id ? '编辑 - ' + this.editData.title : '添加内容');

      this.editImgs = [];
      this.fileList = this.editData.files ? this.editData.files.split(',') : [];
      this.$nextTick(() => {
        this.show = true;
      });

      // 如果是二级学院
      if (this.isXy) {
        this.$set(this.editData, 'xycateid', null);
        // 如果有二分类
        if (this.editData.cateid.length > 1) {
          let _cateids = this.editData.cateid.filter((d, i) => {
            return i > 0;
          }).forEach(d => {
            if (this.xycatemap[d]) {
              this.editData.cateid.splice(this.editData.cateid.indexOf(d), 1);
            }
            this.editData.xycateid = d;
          });
        }
      }

      // set origin data for check modified
      this.setOriaData();
    },
    handleUploadSuccessok(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.sgjpg = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    handleUploadSuccess(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.pic = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },

    handleUploadSuccessVideo(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.editData.video1 = res.obj.pic;
        filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type == 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 20;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    delPic() {
      this.msgbox('确定要删除题图吗？删除后保存生效！', () => {
        this.editData.pic = null;
      });
    },
    delPic2() {
      this.msgbox('确定要删除题图吗？删除后保存生效！', () => {
        this.editData.sgjpg = null;
      });
    },
    delVideo() {
      this.msgbox('确定要删除上传视频吗？删除后保存生效！', () => {
        this.editData.video1 = null;
      });
    },
    handleUploadSuccessFile(res, file, filelist) {
      if (res.obj && res.obj.pic) {
        this.fileList.push(res.obj.pic);
        if (!this.editData.name) {
          this.editData.name = res.obj.pic.substring(res.obj.pic.lastIndexOf('/') + 1, res.obj.pic.lastIndexOf('.'));
        }
        this.editData.files = this.fileList.join(',');
        filelist.forEach(d => {
          if (d.status == 'success') {
            filelist.splice(filelist.indexOf(d), 1);
          }
        });

        // filelist.length = 0;
      } else {
        this.$message.error(res.message || '上传出错啦！');
      }
    },
    delFile(file, index) {
      this.msgbox(`确定要删除该文件吗？`, () => {
        this.$message.success('删除成功！');
        this.fileList.splice(index, 1);
        this.editData.files = this.fileList.join(',');
      });
    },
    editImgOnLoad(json, insertImg) {
      if (json && json.obj && json.obj.pic) {
        let src = json.obj.pic;
        this.editImgs.push(src);
        src = this.rootPath + src;
        insertImg(src);
      }
    },
    imgInsert(src) {
      this.editImgs.push(src);
    },
    upateContent(html, obj) {
      obj.content = html;
    },
    doSave() {
      this.submitform().then(() => {
        console.log(this.editData.sgjpg)
        // if(this.issgr){
        //   if(!this.editData.sgjpg){
        //     alert('必须上传审稿人签字的图片')
        //     return;
        //   }
        // }
        let postData = deepCopy(this.editData);
        this.saveLoading = true;

        postData.rootPath = this.rootPath;
        postData.editImgs = this.editImgs;
        if (postData.createtime instanceof Date) {
          postData.createtime = this.formatDate(postData.createtime, 'yyyy-MM-dd HH:mm:ss');
        }
        if (!this.isSignup) {
          Object.assign(postData, {isup:false, uptime:null, downtime:null, code:null, sales:0, market:null, price:null});
        }

        // 加入二级学院【第二分类】
        if (this.isXy) {
          if (!postData.cateid.includes(postData.xycateid)) {
            postData.cateid.push(postData.xycateid);
          }
        }

        let cateids = [].concat(postData.cateid);
        postData.cateid = cateids[0];
        if (cateids.length > 1) {
          postData.cateid2 = cateids[1];
        }
        if (cateids.length > 2) {
          postData.cateid3 = cateids[2];
        }
        if (cateids.length > 3) {
          postData.cateid4 = cateids[3];
        }

        if (this.fileList.length) {
          postData.files = this.fileList.join(',');
        }

        postData.version === null ? postData.version = 1 : (postData.version += 1);
        this.doPost({
          url: 'sys/news/save',
          data: postData,
          okcb: () => {
            // 更新vuex
            this.$store.commit(types.OTHER.reloadNews);
            // 跳转
            this.setOriaData(0, () => {
              if (postData.id) {
                this.$router.push({name:'news-list'});
              } else {
                this.msgbox('添加成功！确定继续添加，取消返回【内容列表】。', () => {
                  this.getData();
                }, {
                  cancelcb: () => {
                    this.$router.push({name:'news-list'});
                  }
                });
              }
            });
          },
          cb: () => {
            this.saveLoading = false;
          }
        });
      })
      .catch(() => {

      });
    }
  }
}
</script>

<style>
.company-uploader-icon {
    display: inline-block;
    font-size: 4rem;
    color: #8c939d;
    width: 260px;
    height: 68px;
    line-height: 68px;
    text-align: center;
}
.company-uploader .avatar{width:auto; height:68px;}
.company-uploader .jy-upload-preview{position:absolute; left:50%; top:50%; height:68px; transform:translate(-50%, -50%);}
</style>